export const principalRoute = {
  userList: 'user-list',
  userForm: 'user-form',
  userFormId: 'user-form/:id',
  roleList: 'role-list',
  roleForm: 'role-form',
  roleFormId: 'role-form/:id',
  gestoriList: 'gestori-list',
  gestoriForm: 'gestori-form',
  gestoriFormId: 'gestori-form/:id',
  zoneList: 'zone-list',
  zoneForm: 'zone-form',
  zoneFormId: 'zone-form/:id',
  fornitoriList: 'fornitori-list',
  fornitoriForm: 'fornitori-form',
  fornitoriFormId: 'fornitori-form/:id',
  fabbisogniList: 'fabbisogni-list',
  fabbisogniForm: 'fabbisogni-form',
  fabbisogniFormId: 'fabbisogni-form/:id',
  impiantiList: 'impianti-list',
  impiantiForm: 'impianti-form',
  impiantiFormId: 'impianti-form/:id',
  platssZeroList: 'platts-zero-list',
  platssZeroForm:'platts-zero-form',
  platssZeroFormId:'platts-zero-form/:id',
  reportCarichi: 'report-carichi',
  reportPrezziPompa: 'report-prezzi-pompa',
  reportScarichi: 'report-scarichi',
  gestioneIncassi: 'gestione-incassi',
  login: 'login',
  profile: 'profilo-utente',
  unauthorized: 'unauthorized',
};

export const principalRouteNavigate = {
  administration: '/administration',
  login: '/login',
  profile: '/profilo-utente',
  unauthorized: '/unauthorized',
  userDetail: '/user-detail',
  userForm: '/user-form',
  userFormId: '/user-form/:id',
  roleList: '/role-list',
  roleForm: '/role-form',
  roleFormId: '/role-form/:id',
  userList: '/user-list',
  gestoriList: '/gestori-list',
  gestoriForm: '/gestori-form',
  gestoriFormId: '/gestori-form/:id',
  zoneList: '/zone-list',
  zoneForm: '/zone-form',
  zoneFormId: '/zone-form/:id',
  fornitoriList: '/fornitori-list',
  fornitoriForm: '/fornitori-form',
  fornitoriFormId: '/fornitori-form/:id',
  fabbisogniList: 'fabbisogni-list',
  fabbisogniForm: 'fabbisogni-form',
  fabbisogniFormId: 'fabbisogni-form/:id',
  impiantiList: '/impianti-list',
  impiantiForm: '/impianti-form',
  impiantiFormId: '/impianti-form/:id',
  platssZeroList: '/platts-zero-list',
  platssZeroForm:'/platts-zero-form',
  platssZeroFormId:'/platts-zero-form/:id',
  reportCarichi: '/report-carichi',
  reportPrezziPompa: '/report-prezzi-pompa',
  reportScarichi: '/report-scarichi',
  gestioneIncassi: '/gestione-incassi',
};
